import React from 'react';
import { connect } from 'react-redux';
import { LoaderSpiner, LoaderOverlay } from './styles.js';

const Loader = ({ isShowLoader }) => {
  return isShowLoader !== false ? (
    <LoaderOverlay>
      <LoaderSpiner />
    </LoaderOverlay>
  ) : null;
};

const mapStateToProps = state => ({
  isShowLoader: state.core.isShowLoader,
});

export default connect(mapStateToProps)(Loader);
